<template>
  <div>
    <div class="con-tab-ejemplo">
      <vs-list>
        <vs-list-header></vs-list-header>
        <vs-list-item v-for="res in lawsuitHistories" :key="res.id" :title="`${convFormatSeq(res.seq)} ${convFormatDateTime(res.lawsuitDate)}`" :subtitle="`${res.remark}`">
          <vs-button class="btn-icon" size="small" color="danger" v-show="!isHideDelLawsuitHistory(res)" @click="delLawsuitHistory(res.id)">ลบ</vs-button>
        </vs-list-item>
        <div class="mt-2">
          <vs-textarea class="w-full mt-2 mb-2" v-model="form.lawsuitHistory.remark" rows="5"/>
          <vs-button class="btn-icon" size="small" color="success" @click="addLawsuitHistory()">เพิ่มข้อมูล</vs-button>
        </div>
      </vs-list>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment';
import {createNamespacedHelpers} from 'vuex'
const { mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting');

export default {
  data () {
    return {
      form:{
        lawsuitHistory:{
          remark: ""
        }
      }
    }
  },
  computed:{
    ...mapAccountingState([
      'status',
      'contract',
      'lawsuitHistories',
    ])
  },
  methods: {
    ...mapAccountingActions([
      'createLawsuitHistory',
      'deleteLawsuitHistory',
    ]),
    // Function LawsuitHistory
    isHideDelLawsuitHistory (res){
      if( res.seq >= this.lawsuitHistories.length){
        return false
      }
      return true
    },
    async addLawsuitHistory(){
      await this.createLawsuitHistory({
        contractId: this.contract.id,
        form: {
          remark: this.form.lawsuitHistory.remark,
        },
        vm: this
      })
      this.form.lawsuitHistory.remark = ""
    },
    async delLawsuitHistory(id){
      const vm = this
      vm.actionID = id
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: vm.acceptDelLawsuitHistory
      })
    },
    async acceptDelLawsuitHistory () {
      await this.deleteLawsuitHistory({
        form: {
          id: this.actionID
        },
        vm: this
      })
    },
    convFormatSeq(val){
      return `ครั้งที่ ${val}`
    },
    convFormatDateTime(val){
      return `${moment(val).format("วันที่ DD-MM-YYYY เวลา HH.mm น.")}`
    }
  },
}
</script>

<style scoped>
  .vx-coll-fixed-hight{
    display:block;
    width:100%;
    height:400px;
    overflow: auto;
  }
</style>
